export default __webpack_public_path__ + "static/media/fridge2-beforeA-1024w.4621b347.png";